/* Skinny Genie redesign: shared header/footer behaviour.
   Ported from the approved static mockup, with cart + search rewired to
   Shopify's real Cart AJAX API and predictive search endpoint (the mockup
   used a fake localStorage cart and a hardcoded product list for these). */

/* ---------- Shared translation dictionary (English -> Arabic) ---------- */
var SG_DICT_SHARED = {
  "home":"الرئيسية", "Home":"الرئيسية",
  "shop":"المتجر", "Shop":"المتجر",
  "about us":"من نحن", "About us":"من نحن", "About Us":"من نحن",
  "wholesale":"الجملة", "Wholesale":"الجملة",
  "contract manufacturing":"التصنيع بالعقد", "Contract Manufacturing":"التصنيع بالعقد",
  "certifications":"الشهادات", "Certifications":"الشهادات",
  "contact":"تواصل معنا", "Contact":"تواصل معنا", "Contact Us":"تواصل معنا",
  "faq":"الأسئلة الشائعة", "FAQ":"الأسئلة الشائعة",
  "blog":"المدونة", "Blog":"المدونة", "cafés":"المقاهي", "Cafés":"المقاهي", "New":"جديد",
  "Quick links":"روابط سريعة",
  "Shop by Category":"تسوق حسب الفئة", "More Categories":"المزيد من الفئات",
  "Bakery and Pastries":"المخبوزات والمعجنات", "Muffins, cookies & cakes":"مافن، بسكويت وكيك",
  "Bread":"الخبز", "Sandwich loaves & sourdough":"أرغفة الساندويتش والعجين المخمر",
  "Cereals and Granola":"الحبوب والجرانولا", "Healthy breakfast range":"تشكيلة فطور صحي",
  "Flours & Mixes":"الدقيق والخلطات", "Almond, coconut & all-purpose":"لوز، جوز الهند ومتعدد الاستخدامات",
  "Gift Hamper":"سلة هدايا", "Gift baskets, Dubai-wide":"سلال هدايا لجميع أنحاء دبي",
  "Grab & Go":"وجبات سريعة", "Healthy bites on the move":"وجبات خفيفة صحية أثناء التنقل",
  "Keto":"كيتو", "Low-carb, sugar-free":"قليل الكربوهيدرات وخالٍ من السكر",
  "Pizza":"بيتزا", "Crusts & ready-made pizzas":"عجينة بيتزا وبيتزا جاهزة",
  "Ready To Bake":"جاهز للخبز", "Dough for easy home baking":"عجين للخبز المنزلي السهل",
  "Vegan":"نباتي", "Plant-based range":"تشكيلة نباتية بالكامل",
  "Vegan Cheese":"جبن نباتي", "Dairy-free, plant-based":"خالٍ من الألبان ونباتي",
  "Wraps and Tortillas":"اللفائف والتورتيلا", "Low-carb healthy wraps":"لفائف صحية قليلة الكربوهيدرات",
  "Shop All":"تسوق الكل", "Bestsellers":"الأكثر مبيعاً",
  "Chicken Nuggets":"قطع الدجاج", "Pepperoni Pizza":"بيتزا ببيروني",
  "Puff Pastry Sheet":"رقائق عجين البف باستري", "White Bread Loaf":"رغيف خبز أبيض",
  "Find a product":"ابحث عن منتج",
  "Log in":"تسجيل الدخول", "Register":"إنشاء حساب",
  "Sign In / Register":"تسجيل الدخول / إنشاء حساب",
  "Check if we deliver":"تحقق مما إذا كنا", "to you":"نوصل إليك",
  "Check if we deliver to you":"تحقق مما إذا كنا نوصل إليك",
  "Which emirate are you in?":"في أي إمارة أنت؟", "Another emirate":"إمارة أخرى",
  "Pick your emirate below to see our delivery fee and minimum order.":"اختر إمارتك أدناه لمعرفة رسوم التوصيل والحد الأدنى للطلب.",
  "See our delivery fees and minimum order for your emirate.":"اطّلع على رسوم التوصيل والحد الأدنى للطلب في إمارتك.",
  "Yes, we deliver across Dubai.":"نعم، نوصل إلى جميع أنحاء دبي.",
  "Yes, we deliver to Abu Dhabi.":"نعم، نوصل إلى أبوظبي.",
  "Yes, we deliver to Sharjah.":"نعم، نوصل إلى الشارقة.",
  "AED 25 delivery, free on orders of AED 120 or more. No minimum order.":"رسوم التوصيل 25 درهم، والتوصيل مجاني للطلبات بقيمة 120 درهم أو أكثر. لا يوجد حد أدنى للطلب.",
  "Delivery in 1-2 days.":"التوصيل خلال 1-2 يوم.",
  "AED 40 delivery. Minimum order AED 120.":"رسوم التوصيل 40 درهم. الحد الأدنى للطلب 120 درهم.",
  "Delivery on Monday, Wednesday and Friday only, 48 hour lead time.":"التوصيل أيام الاثنين والأربعاء والجمعة فقط، مع مهلة تجهيز 48 ساعة.",
  "48 hour delivery lead time.":"مهلة التوصيل 48 ساعة.",
  "We don’t deliver to Al Ain or Al Dhafra.":"لا نوصل إلى العين أو الظفرة.",
  "Sorry, we don’t deliver there yet.":"عذرًا، لا نوصل إلى هذه المنطقة حاليًا.",
  "We deliver across Dubai, Abu Dhabi (excl. Al Ain & Al Dhafra) & Sharjah.":"نوصل إلى جميع أنحاء دبي وأبوظبي (باستثناء العين والظفرة) والشارقة.",
  "Dubai":"دبي", "Abu Dhabi":"أبوظبي", "Sharjah":"الشارقة",
  "Abu Dhabi (excl. Al Ain & Al Dhafra) & Sharjah":"أبوظبي (باستثناء العين والظفرة) والشارقة",
  ": AED 25 delivery, free above AED 120":": توصيل بـ 25 درهم، مجاني للطلبات فوق 120 درهم",
  ": AED 40 delivery, min. order AED 120":": توصيل بـ 40 درهم، بحد أدنى للطلب 120 درهم",
  "Free above AED 120":"توصيل مجاني للطلبات فوق 120 درهم",
  "Address: Dubai":"العنوان: دبي",
  "Skinny Genie Production Facility":"منشأة إنتاج Skinny Genie",
  "Building No 59 - Warehouse No.1 28B Street - Al Quoz - Al Quoz Industrial Area 3 - Dubai":"مبنى رقم 59 - مستودع رقم 1 شارع 28B - القوز - منطقة القوز الصناعية 3 - دبي",
  "Phone:":"الهاتف:", "For inquiries contact:":"للاستفسارات يرجى التواصل عبر:",
  "We send delicious newsletters":"نرسل لكم نشرات إخبارية شهية", "Email":"البريد الإلكتروني",
  "No reviews yet":"لا توجد تقييمات بعد", "Price on request":"السعر عند الطلب",
  "Add":"أضف", "Add to cart":"أضف إلى السلة", "You May Also Like":"قد يعجبك أيضاً"
};

/* Each template can define its own SG_DICT_PAGE (page-specific strings)
   before this file runs. Falls back to an empty object when absent.
   SG_DICT_EXTRA and SG_DICT_PATTERNS come from skinny-genie-i18n-ar.js,
   which layout/theme.liquid loads before this file on Arabic pages only. */
var SG_DICT = Object.assign({}, SG_DICT_SHARED,
  (typeof SG_DICT_EXTRA !== 'undefined' ? SG_DICT_EXTRA : {}),
  (typeof SG_DICT_PAGE !== 'undefined' ? SG_DICT_PAGE : {}));
var SG_PATTERNS = (typeof SG_DICT_PATTERNS !== 'undefined') ? SG_DICT_PATTERNS : [];

/* ---------- Language ----------
   The language is Shopify's own locale, read from <html lang>, which
   layout/theme.liquid sets from request.locale. Arabic pages live under
   /ar/, where Shopify serves the Arabic product, collection, page and
   checkout translations. The dictionary above only covers the theme's
   own wording on those pages; the toggle navigates between locales. */
var SG_PAGE_LANG = ((document.documentElement.getAttribute('lang') || 'en').slice(0, 2) === 'ar') ? 'ar' : 'en';
var SG_LANG = SG_PAGE_LANG;

/* Path of the same page in the other locale, keeping query and hash. */
function sgLocalePath(path, lang){
  var bare = (path || '/').replace(/^\/ar(?=\/|$)/, '') || '/';
  return lang === 'ar' ? '/ar' + (bare === '/' ? '' : bare) : bare;
}

function sgLookup(text){
  var key = text.trim().replace(/\s+/g, ' ');
  if(!key) return null;
  if(SG_DICT[key]) return SG_DICT[key];
  for(var i = 0; i < SG_PATTERNS.length; i++){
    var m = key.match(SG_PATTERNS[i][0]);
    if(m){ var out = SG_PATTERNS[i][1](m, SG_DICT); if(out) return out; }
  }
  /* "Vegan (33 products)": translate the label, keep the count. */
  var c = key.match(/^(.+?)\s*(\([^()]*\))$/);
  if(c && SG_DICT[c[1]]) return SG_DICT[c[1]] + ' ' + c[2];
  return null;
}

function sgTranslateNode(node, lang){
  if(node.nodeType === 3){
    /* A script may rewrite a node after it was translated (the header
       language label does); the new text then becomes the original. */
    if(node.__sgOrig === undefined || node.nodeValue !== node.__sgLast){ node.__sgOrig = node.nodeValue; }
    var orig = node.__sgOrig;
    var tr = (lang === 'ar') ? sgLookup(orig) : null;
    if(tr){
      var lead = orig.match(/^\s*/)[0], trail = orig.match(/\s*$/)[0];
      node.nodeValue = lead + tr + trail;
    }
    node.__sgLast = node.nodeValue;
    return;
  }
  if(node.nodeType !== 1) return;
  var tag = node.tagName;
  if(tag === 'SCRIPT' || tag === 'STYLE' || tag === 'SVG') return;
  ['placeholder','aria-label','title'].forEach(function(attr){
    if(node.hasAttribute && node.hasAttribute(attr)){
      var origKey = 'data-sg-orig-' + attr;
      var origVal = node.getAttribute(origKey);
      if(origVal === null){ origVal = node.getAttribute(attr); node.setAttribute(origKey, origVal); }
      var trAttr = (lang === 'ar') ? sgLookup(origVal) : null;
      node.setAttribute(attr, trAttr || origVal);
    }
  });
  var children = node.childNodes;
  for(var i=0;i<children.length;i++){ sgTranslateNode(children[i], lang); }
}
function sgReapply(){ sgTranslateNode(document.body, SG_LANG); }

/* Switching language loads the same page in the other Shopify locale, so
   product and page content comes from Shopify's translations. On the
   page's own language it only (re)applies the direction and dictionary. */
function setLanguage(lang){
  if(lang !== SG_PAGE_LANG){
    var search = window.location.search;
    /* On a draft theme, carry the preview across, as skinny-genie-preview.js
       does for links; otherwise the other locale opens the live theme. */
    var theme = window.Shopify && window.Shopify.theme;
    if(theme && theme.role && theme.role !== 'main' && search.indexOf('preview_theme_id=') === -1){
      search += (search ? '&' : '?') + 'preview_theme_id=' + theme.id;
    }
    window.location.href = sgLocalePath(window.location.pathname, lang) + search + window.location.hash;
    return;
  }
  SG_LANG = lang;
  document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
  document.body.classList.toggle('lang-ar', lang === 'ar');
  if(lang === 'ar'){ sgTranslateNode(document.body, lang); }
}
function selectLang(el, lang){
  setLanguage(lang);
  return false;
}

/* Content drawn after load (cart drawer, search results, filters, reviews
   widgets) is translated as it arrives. Only additions are observed, so the
   translator's own text changes do not retrigger it. */
if(SG_PAGE_LANG === 'ar' && window.MutationObserver){
  new MutationObserver(function(records){
    records.forEach(function(r){
      for(var i = 0; i < r.addedNodes.length; i++){ sgTranslateNode(r.addedNodes[i], 'ar'); }
    });
  }).observe(document.documentElement, {childList: true, subtree: true});
}
document.addEventListener('DOMContentLoaded', function(){
  setLanguage(SG_LANG);
  var ddItem = document.querySelector('.site-lang-item');
  if(ddItem){
    ddItem.querySelectorAll('.lang-option').forEach(function(a){
      a.classList.toggle('active', a.getAttribute('data-lang') === SG_LANG);
    });
    var btn = ddItem.querySelector('.site-lang');
    if(btn && btn.childNodes[0]){ btn.childNodes[0].textContent = (SG_LANG === 'ar' ? 'العربية' : 'English') + ' '; }
  }
});

/* ---------- Desktop mega menu (hover open/close) ---------- */
(function(){
  var navItem = document.querySelector('.site-nav-item');
  if(!navItem) return;
  var menu = navItem.querySelector('.nav-megamenu');
  if(!menu) return;
  var closeTimer;
  function openMenu(){
    clearTimeout(closeTimer);
    menu.classList.add('mega-open');
  }
  function scheduleClose(){
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function(){ menu.classList.remove('mega-open'); }, 300);
  }
  navItem.addEventListener('mouseenter', openMenu);
  navItem.addEventListener('mouseleave', scheduleClose);
  menu.addEventListener('mouseenter', openMenu);
  menu.addEventListener('mouseleave', scheduleClose);
})();

/* ---------- Mobile nav ---------- */
function toggleMobileNav(){
  var nav = document.getElementById('site-nav');
  var btn = document.getElementById('nav-toggle-btn');
  var overlay = document.getElementById('site-nav-overlay');
  if(!nav || !btn) return;
  var open = !nav.classList.contains('mobile-open');
  if(open){
    var logo = document.querySelector('.site-logo-link');
    if(logo && window.innerWidth <= 900){ nav.style.top = logo.getBoundingClientRect().bottom + 'px'; }
    else{
      var header = document.querySelector('.site-header');
      if(header){ nav.style.top = header.getBoundingClientRect().bottom + 'px'; }
    }
  }
  nav.classList.toggle('mobile-open', open);
  if(overlay){ overlay.classList.toggle('open', open); }
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  document.body.classList.toggle('nav-locked', open);
}
function toggleMobileShopSubmenu(){
  var submenu = document.getElementById('mobile-shop-submenu');
  var btn = document.getElementById('mobile-shop-toggle');
  if(!submenu || !btn) return;
  var open = !submenu.classList.contains('open');
  submenu.classList.toggle('open', open);
  btn.classList.toggle('open', open);
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
}

/* ---------- Delivery checker (emirate buttons) ----------

   The customer picks their emirate from four buttons and the answer is fixed
   text below. There is deliberately NO free-text box and NO map lookup.

   Why: delivery price depends only on the emirate, and checkout charges by
   emirate from the address anyway. The old checker geocoded whatever was
   typed through the free Nominatim service, which answered wrongly: "London"
   matched a furniture shop in Sharjah and "Wales" a school in Abu Dhabi, so the
   site promised delivery to both. Tightening the lookup helped, but the free
   service also gave inconsistent answers between identical requests, and a
   paid geocoder would still be guessing. The user chose buttons on
   2026-09-28.

   One copy of the figures, here. The header modal and the Contact page card
   both call checkDelivery(zone, root), where root is the element holding
   the buttons and the .location-result box. */
var SG_DELIVERY_ZONES = {
  dubai: {
    ok: true,
    title: 'Yes, we deliver across Dubai.',
    lines: ['AED 25 delivery, free on orders of AED 120 or more. No minimum order.',
            'Delivery in 1-2 days.']
  },
  abudhabi: {
    ok: true,
    title: 'Yes, we deliver to Abu Dhabi.',
    lines: ['AED 40 delivery. Minimum order AED 120.',
            'Delivery on Monday, Wednesday and Friday only, 48 hour lead time.'],
    note: 'We don&rsquo;t deliver to Al Ain or Al Dhafra.'
  },
  sharjah: {
    ok: true,
    title: 'Yes, we deliver to Sharjah.',
    lines: ['AED 40 delivery. Minimum order AED 120.',
            '48 hour delivery lead time.']
  },
  other: {
    ok: false,
    title: 'Sorry, we don&rsquo;t deliver there yet.',
    lines: ['We deliver across Dubai, Abu Dhabi (excl. Al Ain &amp; Al Dhafra) &amp; Sharjah.']
  }
};

function checkDelivery(zone, root){
  root = root || document.getElementById('location-modal-overlay');
  if(!root){ return; }
  var result = root.querySelector('.location-result');
  var z = SG_DELIVERY_ZONES[zone];
  root.querySelectorAll('.location-chip[data-zone]').forEach(function(btn){
    var on = (btn.getAttribute('data-zone') === zone);
    btn.classList.toggle('active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  if(!result || !z){ return; }
  result.className = 'location-result ' + (z.ok ? 'success' : 'fail');
  result.innerHTML = '<strong>' + z.title + '</strong><br>' + z.lines.join('<br>') +
    (z.note ? '<span class="location-result-note">' + z.note + '</span>' : '');
  sgReapply();
}

function openLocationModal(){
  var overlay = document.getElementById('location-modal-overlay');
  overlay.classList.add('active');
  var result = overlay.querySelector('.location-result');
  result.className = 'location-result';
  result.textContent = '';
  overlay.querySelectorAll('.location-chip[data-zone]').forEach(function(btn){
    btn.classList.remove('active');
    btn.setAttribute('aria-pressed', 'false');
  });
  var first = overlay.querySelector('.location-chip');
  if(first){ first.focus(); }
}
function closeLocationModal(){
  document.getElementById('location-modal-overlay').classList.remove('active');
}
function sgEscapeHtml(str){
  return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
}

/* ---------- Feedback tab / modal ---------- */
var feedbackScore = null;
function openFeedbackModal(){
  document.getElementById('feedback-modal-overlay').classList.add('active');
  feedbackScore = null;
  document.querySelectorAll('#feedback-scale-grid button').forEach(function(btn){ btn.classList.remove('selected'); });
  document.getElementById('feedback-reason-select').value = '';
  document.getElementById('feedback-suggestion-input').value = '';
  document.querySelectorAll('input[name="feedback-issue"]').forEach(function(r){ r.checked = (r.value === 'No'); });
  document.querySelectorAll('input[name="feedback-contact"]').forEach(function(r){ r.checked = (r.value === 'No'); });
}
function closeFeedbackModal(){
  document.getElementById('feedback-modal-overlay').classList.remove('active');
}
function setFeedbackScore(n){
  feedbackScore = n;
  document.querySelectorAll('#feedback-scale-grid button').forEach(function(btn){
    btn.classList.toggle('selected', parseInt(btn.getAttribute('data-score'), 10) === n);
  });
}
function submitFeedback(){
  var reason = document.getElementById('feedback-reason-select').value || 'Not specified';
  var suggestion = document.getElementById('feedback-suggestion-input').value || 'None provided';
  var issue = document.querySelector('input[name="feedback-issue"]:checked');
  var contact = document.querySelector('input[name="feedback-contact"]:checked');
  var body = 'Satisfaction score (0-10): ' + (feedbackScore === null ? 'Not answered' : feedbackScore) + '%0D%0A' +
             'Primary reason for visit: ' + encodeURIComponent(reason) + '%0D%0A' +
             'Experienced an issue: ' + (issue ? encodeURIComponent(issue.value) : 'Not answered') + '%0D%0A' +
             'Suggestions to improve the site: ' + encodeURIComponent(suggestion) + '%0D%0A' +
             'May we contact you: ' + (contact ? encodeURIComponent(contact.value) : 'Not answered') + '%0D%0A' +
             'Page: ' + encodeURIComponent(window.location.href);
  window.location.href = 'mailto:info@skinny-genie.com?subject=' + encodeURIComponent('Website feedback') + '&body=' + body;
  closeFeedbackModal();
}

/* ---------- Favourites (client-side wishlist; no native Shopify equivalent
   without a metafield/app-backed solution, kept as a lightweight enhancement) ---------- */
function getFavourites(){
  try{ return JSON.parse(localStorage.getItem('sg_favourites') || '[]'); }catch(e){ return []; }
}
function saveFavourites(list){
  localStorage.setItem('sg_favourites', JSON.stringify(list));
}
function toggleFavourite(slug){
  var list = getFavourites();
  var idx = list.indexOf(slug);
  if(idx === -1){ list.push(slug); } else { list.splice(idx, 1); }
  saveFavourites(list);
  updateFavCount();
  return idx === -1;
}
function updateFavCount(){
  var count = getFavourites().length;
  document.querySelectorAll('#site-fav-count, #mobile-nav-fav-count').forEach(function(el){
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
  /* A class, not an id: the tab pair is rendered in BOTH drawer heads. */
  document.querySelectorAll('.js-fav-tab-count').forEach(function(el){
    el.textContent = count > 0 ? '(' + count + ')' : '';
  });
}
function initFavouriteHearts(){
  var list = getFavourites();
  document.querySelectorAll('.bs-fav-heart').forEach(function(btn){
    var card = btn.closest('.bs-card');
    var key = card && card.getAttribute('data-product-key');
    var slug = key ? key.split('/').pop() : null;
    if(slug && list.indexOf(slug) !== -1){ btn.classList.add('active'); }
  });
}
function openFavDrawer(){
  renderFavDrawer();
  sgSyncDrawerTabs('fav');
  sgResetDrawerParking();
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-drawer-overlay').classList.remove('open');
  document.getElementById('fav-drawer-overlay').classList.add('open');
  document.getElementById('fav-drawer').classList.add('open');
  document.body.classList.add('cart-drawer-locked');
}
function closeFavDrawer(){
  document.getElementById('fav-drawer-overlay').classList.remove('open');
  document.getElementById('fav-drawer').classList.remove('open');
  document.body.classList.remove('cart-drawer-locked');
  sgReparkTimer = setTimeout(sgResetDrawerParking, 300);
}
function favDrawerRemove(slug, cardEl){
  toggleFavourite(slug);
  renderFavDrawer();
  document.querySelectorAll('.bs-fav-heart').forEach(function(btn){
    var card = btn.closest('.bs-card');
    if(card && card.getAttribute('data-product-key') && card.getAttribute('data-product-key').split('/').pop() === slug){
      btn.classList.remove('active');
    }
  });
}
/* Rows come from the SERVER, one request per favourite, not from
   /products/<handle>.js.

   TWO failed approaches are recorded here because each looked right:

   1. window.__sgFavProductCache. The old code filtered the saved handles
      against it and rendered only what it found. NOTHING in the theme ever
      wrote that object; the read was its only mention in any asset, snippet,
      section or template, so the filter always matched nothing and every
      customer saw "You haven't saved any favourites yet." however many hearts
      they had clicked. Verified on the draft before replacing it: sg_favourites
      held one handle and the header badge read 1 while the drawer rendered
      empty.

   2. /products/<handle>.js. It fixed the above, but a Shopify JSON payload
      carries NO METAFIELDS, exactly as /cart.js does not, so custom.box_size
      (the pack size, "350g*1pc") was unreachable and these rows showed a title
      and a price while the cart rows beside them showed the pack size. The user
      spotted the missing grams on 2026-09-23.

   templates/product.favrow.liquid renders the row with Liquid, so the metafield
   and Shopify's own money filter are both available. Same trick as
   templates/cart.drawer.liquid, and for the same reason: an ordinary page
   request respects the theme preview, while ?sections= does not.

   A handle whose product is gone, unpublished or renamed 404s, comes back null
   and is DROPPED from sg_favourites, so a stale favourite cannot sit there
   forever inflating the badge against something nobody can open. The marker
   check guards against a 404 page that still returns 200. */
var sgFavRows = {};
var sgFavRenderSeq = 0;

/* routes.cart_url carries the locale prefix when the store has one, so
   deriving the root from it keeps these requests on the page's own locale. */
function sgShopRoot(){
  var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  return cartUrl.replace(/\/cart$/, '');
}

function sgFetchFavRow(handle){
  if(Object.prototype.hasOwnProperty.call(sgFavRows, handle)){
    return Promise.resolve(sgFavRows[handle]);
  }
  return fetch(sgShopRoot() + '/products/' + encodeURIComponent(handle) + '?view=favrow', {credentials: 'same-origin'})
    .then(function(r){ return r.ok ? r.text() : null; })
    .then(function(html){
      if(html && html.indexOf('cart-drawer-item') === -1){ html = null; }
      sgFavRows[handle] = html;
      return html;
    })
    .catch(function(){ return null; });
}

function renderFavDrawer(){
  var list = getFavourites();
  var itemsEl = document.getElementById('fav-drawer-items');
  var emptyEl = document.getElementById('fav-drawer-empty');
  if(!itemsEl || !emptyEl){ return; }
  if(!list.length){
    itemsEl.innerHTML = '';
    itemsEl.style.display = 'none';
    emptyEl.style.display = 'flex';
    return;
  }
  var seq = ++sgFavRenderSeq;
  Promise.all(list.map(sgFetchFavRow)).then(function(rows){
    if(seq !== sgFavRenderSeq){ return; }
    var gone = [];
    var html = '';
    rows.forEach(function(row, i){
      if(!row){ gone.push(list[i]); return; }
      html += row;
    });
    if(gone.length){
      saveFavourites(list.filter(function(h){ return gone.indexOf(h) === -1; }));
      updateFavCount();
    }
    if(!html){
      itemsEl.innerHTML = '';
      itemsEl.style.display = 'none';
      emptyEl.style.display = 'flex';
      return;
    }
    emptyEl.style.display = 'none';
    itemsEl.style.display = 'block';
    itemsEl.innerHTML = html;
    /* The rows arrive after the synchronous pass in any caller, so Arabic has
       to be applied again, exactly as renderCartDrawer does. */
    sgReapply();
  });
}

/* MOVES a favourite into the cart: adds it, then takes it off the list.

   The user decided this on 2026-09-23. It shipped for a few hours as "Add to
   cart", keeping the item in favourites, on the reasoning that a favourite here
   is probably a repeat staple and emptying the list on purchase would delete
   the thing somebody saved. That was raised and the user chose move, so the
   label says "Move to cart" rather than hiding half the action behind "Add".

   The removal goes through favDrawerRemove(), the existing remove path, so it
   also clears the heart on any product card on the page; the capture-phase
   listener in skinny-genie-product.js then repaints the product page button.
   Doing it any other way would leave those two out of sync.

   It still does NOT call sgAddToCart(), whose last step opens the cart drawer.
   That would throw you off the Favourites panel after every single move;
   staying put lets someone clear three things in a row, and the Cart tab count
   ticking up is feedback enough.

   The 900ms gap is deliberate: "Added" has to be visible before the row
   disappears, or the tap reads as having done nothing at all. data-busy guards
   a double tap inside that window, which would otherwise add a second one
   silently. On failure the label is restored and the favourite is KEPT, since
   nothing reached the cart. */
function sgFavAddToCart(el, variantId, handle){
  if(!variantId || el.getAttribute('data-busy') === '1'){ return false; }
  el.setAttribute('data-busy', '1');
  var original = el.textContent;
  el.textContent = 'Adding';
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
  })
    .then(function(r){ return r.json(); })
    .then(function(){ return sgFetchCart(); })
    .then(function(cart){
      updateCartUI(cart);
      el.textContent = 'Added';
      setTimeout(function(){
        if(handle){ favDrawerRemove(handle); }
      }, 900);
    })
    .catch(function(){
      el.textContent = original;
      el.removeAttribute('data-busy');
    });
  return false;
}

/* ---------- Cart / Favourites tabs in the drawer head (mobile) ----------

   The two panels are the two drawers that already existed, so switching is
   just moving the .open class between them: nothing re-mounts, the body scroll
   lock never lifts, and both overlays are the same flat scrim so cross-fading
   one out as the other fades in is not visible.

   Deliberately NOT merged into a single drawer with two panes. Both are also
   opened directly from the header, by the cart pill and by the heart, and
   those entry points had to keep working exactly as they did. */
function sgSyncDrawerTabs(panel){
  document.querySelectorAll('.drawer-tab').forEach(function(tab){
    var on = (tab.getAttribute('data-panel') === panel);
    tab.classList.toggle('active', on);
    tab.setAttribute('aria-selected', on ? 'true' : 'false');
  });
}

function sgDrawers(){
  return {cart: document.getElementById('cart-drawer'), fav: document.getElementById('fav-drawer')};
}
/* Suppresses the 0.25s transform transition on both panels, for the frames
   where a position must be applied instantly rather than animated.

   The reflow on the way OUT is the whole trick, and it has to happen BEFORE the
   class comes off. Everything between sgNoAnim(true) and sgNoAnim(false) runs in
   one synchronous block, so without a forced style flush the browser never
   observes the suppressed state at all: it sees one net change, from the old
   position with transitions on to the new position with transitions on, and
   animates it. Measured on the draft 2026-09-23 with the reflow in the wrong
   place: 200ms after a close the cart panel read -19px instead of parked at
   +375, i.e. it was sailing straight across the screen in full view. Reading
   offsetWidth while sg-no-anim is still applied commits the new position with
   no transition; only then is it safe to hand transitions back. */
function sgNoAnim(on){
  var d = sgDrawers();
  if(!d.cart || !d.fav){ return; }
  if(!on){ void d.cart.offsetWidth; }
  d.cart.classList.toggle('sg-no-anim', on);
  d.fav.classList.toggle('sg-no-anim', on);
}
/* Both panels back to their resting place off the RIGHT edge, instantly.

   After a forward switch the cart is parked off the LEFT edge, which is correct
   while the pair is a carousel but wrong for a drawer being opened fresh from
   the header. Re-parking has to be instant: animated, the panel would travel
   from -100% to +100% straight across the viewport in full view. */
var sgReparkTimer = null;
function sgResetDrawerParking(){
  var d = sgDrawers();
  clearTimeout(sgReparkTimer);
  if(!d.cart || !d.fav){ return; }
  sgNoAnim(true);
  d.cart.style.transform = '';
  d.fav.style.transform = '';
  d.cart.classList.remove('sg-left');
  d.fav.classList.remove('sg-left');
  sgNoAnim(false);
}

/* Switching tabs moves BOTH panels the same way, like a carousel.

   Measured on the draft 2026-09-23, before this: the outgoing panel animated to
   +100% while the incoming came from +100%, so they travelled in OPPOSITE
   directions and crossed at about 110ms (cart at 217px, favourites at 158px).
   Both are z-index 601 and the cart is later in the DOM, so the panel that was
   LEAVING painted on top of the one arriving. That crossover is what read as
   unsmooth, not the duration.

   Now: going to Favourites the pair slides left, so the cart parks off the LEFT
   edge (.sg-left) and favourites arrives from the right. Coming back, the pair
   slides right: favourites parks off the right as usual and the cart returns
   from the left it was parked on. The two panels stay exactly one width apart
   throughout, so they never overlap and stacking order stops mattering. */
function sgDrawerTab(panel){
  var d = sgDrawers();
  if(!d.cart || !d.fav){ return; }
  var wantCart = (panel === 'cart');
  var incoming = wantCart ? d.cart : d.fav;
  var outgoing = wantCart ? d.fav : d.cart;
  /* Hand control back to the classes; any drag position animates from where it
     was left to where the classes say it belongs. */
  d.cart.style.transform = '';
  d.fav.style.transform = '';
  outgoing.classList.remove('open');
  outgoing.classList.toggle('sg-left', !wantCart);
  incoming.classList.remove('sg-left');
  incoming.classList.add('open');
  document.getElementById('cart-drawer-overlay').classList.toggle('open', wantCart);
  document.getElementById('fav-drawer-overlay').classList.toggle('open', !wantCart);
  document.body.classList.add('cart-drawer-locked');
  sgSyncDrawerTabs(panel);
  if(wantCart){ sgFetchCart().then(updateCartUI); } else { renderFavDrawer(); }
}

/* The swipe follows the finger rather than waiting for release.

   Panels are positioned as a PAIR: the one you are on sits at dx, the one you
   are heading to sits exactly one width away at dx +/- w. At dx = -w the pair
   has advanced by exactly one panel, which is the same geometry sgDrawerTab
   animates to, so the handover at release is seamless.

   Engagement is deliberate. Nothing moves until the drag is 12px AND more
   horizontal than vertical, so a thumb scrolling a long cart never drags the
   panel sideways; once vertical wins, this gesture gives up for good and lets
   the list scroll. touch-action:pan-y (see skinny-genie-mobile.css) tells the
   browser the same thing, so the vertical scroll stays on the compositor.

   Release commits at a quarter of the panel width, otherwise it springs back.
   Dragging toward a panel that is not there is clamped to 0 rather than
   rubber-banded: the cart is the first tab and has nothing to its left. */
var SG_DRAWER_COMMIT = 0.25;
var SG_DRAWER_ENGAGE_PX = 12;
function sgInitDrawerSwipe(){
  var d = sgDrawers();
  if(!d.cart || !d.fav){ return; }
  var startX = 0, startY = 0, dx = 0;
  var tracking = false, engaged = false, from = null;

  function openPanel(){
    if(d.cart.classList.contains('open')){ return 'cart'; }
    if(d.fav.classList.contains('open')){ return 'fav'; }
    return null;
  }
  function onStart(e){
    engaged = false;
    dx = 0;
    if(e.touches.length !== 1 || !window.matchMedia('(max-width:900px)').matches){ tracking = false; return; }
    from = openPanel();
    tracking = (from !== null);
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }
  function onMove(e){
    if(!tracking){ return; }
    var t = e.touches[0];
    var mx = t.clientX - startX;
    var my = t.clientY - startY;
    if(!engaged){
      if(Math.abs(my) > 10 && Math.abs(my) >= Math.abs(mx)){ tracking = false; return; }
      if(Math.abs(mx) < SG_DRAWER_ENGAGE_PX){ return; }
      engaged = true;
      sgNoAnim(true);
    }
    if(e.cancelable){ e.preventDefault(); }
    var w = d.cart.getBoundingClientRect().width;
    dx = (from === 'cart') ? Math.min(0, mx) : Math.max(0, mx);
    var cur = (from === 'cart') ? d.cart : d.fav;
    var other = (from === 'cart') ? d.fav : d.cart;
    cur.style.transform = 'translateX(' + dx + 'px)';
    other.style.transform = 'translateX(' + (((from === 'cart') ? w : -w) + dx) + 'px)';
  }
  function onEnd(){
    if(!tracking){ return; }
    tracking = false;
    if(!engaged){ return; }
    engaged = false;
    sgNoAnim(false);
    var w = d.cart.getBoundingClientRect().width;
    if(Math.abs(dx) > w * SG_DRAWER_COMMIT){
      sgDrawerTab(from === 'cart' ? 'fav' : 'cart');
    } else {
      d.cart.style.transform = '';
      d.fav.style.transform = '';
    }
  }
  [d.cart, d.fav].forEach(function(el){
    el.addEventListener('touchstart', onStart, {passive: true});
    el.addEventListener('touchmove', onMove, {passive: false});
    el.addEventListener('touchend', onEnd, {passive: true});
    el.addEventListener('touchcancel', onEnd, {passive: true});
  });
}

/* ---------- Cart (real Shopify Cart AJAX API) ---------- */
function sgMoney(cents){
  return 'AED ' + (cents / 100).toFixed(2);
}
/* skipRows is passed only by the DOMContentLoaded call below. See
   renderCartDrawer for why. */
function updateCartUI(cart, skipRows){
  var totalEl = document.getElementById('cart-total-amount');
  var subEl = document.getElementById('cart-sub-text');
  if(totalEl){ totalEl.textContent = sgMoney(cart.total_price); }
  if(subEl){ subEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item in cart' : ' items in cart'); }
  renderCartDrawer(cart, skipRows);
  sgReapply();
}
function sgFetchCart(){
  return fetch(window.routes.cart_url + '.js').then(function(r){ return r.json(); });
}
function openCartDrawer(){
  sgSyncDrawerTabs('cart');
  sgResetDrawerParking();
  document.getElementById('fav-drawer').classList.remove('open');
  document.getElementById('fav-drawer-overlay').classList.remove('open');
  document.getElementById('cart-drawer-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.classList.add('cart-drawer-locked');
  sgFetchCart().then(updateCartUI);
}
function closeCartDrawer(){
  document.getElementById('cart-drawer-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.classList.remove('cart-drawer-locked');
  /* Let the close animation finish, then re-park, so the panel that was sitting
     off the LEFT edge is back on the right before anything reopens. */
  sgReparkTimer = setTimeout(sgResetDrawerParking, 300);
}
/* Guards for rapid taps on the drawer stepper.

   The stepper bakes the quantity that was current when the ROW WAS RENDERED
   into its own onclick. Two taps 120ms apart therefore both compute from the
   same stale number and both send the same target, so one of them is silently
   lost. Measured 2026-09-22: two minus taps on a line of 3 left it at 2, not 1.
   The server and the display still agreed, so nothing looked broken; the tap
   just did not count.

   sgQtyTarget remembers what the most recent tap ASKED FOR, per line, so the
   next tap adds to that instead of to the stale baked value. It is cleared once
   the last outstanding change for that line returns, after which the freshly
   rendered onclick is authoritative again.

   sgCartSeq discards any response a newer change has already superseded.
   Without it, two changes in flight can resolve out of order and the older one
   rolls the title, total and rows back to a state the cart has already left. */
var sgQtyTarget = {};
var sgQtySeq = {};
var sgCartSeq = 0;
/* EVERY cart write goes through this one promise chain, so only one
   /cart/change.js request is ever in flight.

   Shopify does NOT serialise concurrent writes to the same cart, and the
   result is not merely out of order, it is LOST. Measured directly on
   2026-09-22, firing quantities 4 then 3 then 2 at one line:

     fired concurrently   cart ended at 4   (two writes thrown away)
     fired one after another   cart ended at 2   (correct)

   That race predates the optimistic paint: three fast taps always under
   counted. It was invisible because the display was rebuilt from the server
   afterwards, so the wrong number still looked self-consistent. Painting the
   tap immediately turned a silent miscount into a visible lie, which is how it
   was finally caught.

   The chain never rejects: the inner catch resolves it, so one failed write
   cannot wedge every later tap. */
var sgCartChain = Promise.resolve();
function cartDrawerChangeQty(key, quantity){
  var seq = ++sgCartSeq;
  sgQtySeq[key] = seq;
  sgCartChain = sgCartChain.then(function(){
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: quantity})
    })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(sgQtySeq[key] === seq){
          delete sgQtyTarget[key];
          delete sgQtySeq[key];
        }
        /* Skip the repaint for every write except the newest, so a burst of
           taps costs ONE row refetch rather than one per tap. */
        if(seq !== sgCartSeq) return;
        updateCartUI(cart);
      })
      .catch(function(){
        /* The optimistic number is now a lie: the change never landed. Drop the
           remembered target and re-sync the whole drawer from the server, so the
           display cannot sit on a quantity the cart does not have. */
        delete sgQtyTarget[key];
        delete sgQtySeq[key];
        return sgFetchCart().then(updateCartUI).catch(function(){});
      });
  });
  return sgCartChain;
}
/* Paints the tapped quantity straight away instead of waiting for the row
   refetch, which is a server round trip and reads as an unresponsive button on
   a fast tap. The number is the ONLY thing shown optimistically: the line
   price, the cart total and the item count all stay server-truth, because
   guessing money is a worse failure than a number that lags by 300ms.

   The row is found by data-key rather than by passing `this` from the onclick,
   so the markup change is purely ADDITIVE. Old rendered rows simply have no
   data-key, miss the optimistic paint and still work; nothing breaks in the
   window between pushing the snippet and pushing this file.

   Nothing is painted for a drop to 0: that line is about to disappear, and
   showing "0" first would just flicker. */
function sgPaintQty(key, qty){
  if(qty < 1) return;
  var rows = document.querySelectorAll('#cart-drawer-items .cart-drawer-item[data-key]');
  for(var i = 0; i < rows.length; i++){
    if(rows[i].getAttribute('data-key') === key){
      var el = rows[i].querySelector('.bs-step-qty');
      if(el){ el.textContent = qty; }
      return;
    }
  }
}
function cartDrawerStepQty(key, currentQty, delta){
  var base = (sgQtyTarget[key] === undefined) ? currentQty : sgQtyTarget[key];
  var next = base + delta;
  if(next < 0){ next = 0; }
  sgQtyTarget[key] = next;
  sgPaintQty(key, next);
  cartDrawerChangeQty(key, next);
}
function cartDrawerRemoveItem(key){
  sgQtyTarget[key] = 0;
  cartDrawerChangeQty(key, 0);
}
var sgDrawerRenderSeq = 0;
function renderCartDrawer(cart, skipRows){
  var titleEl = document.getElementById('cart-drawer-title');
  var itemsEl = document.getElementById('cart-drawer-items');
  var emptyEl = document.getElementById('cart-drawer-empty');
  var footerEl = document.getElementById('cart-drawer-footer');
  if(!itemsEl) return;
  titleEl.textContent = 'Your Cart (' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)');
  document.querySelectorAll('.js-cart-tab-count').forEach(function(el){
    el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
  });
  if(cart.item_count === 0){
    itemsEl.style.display = 'none';
    footerEl.style.display = 'none';
    emptyEl.style.display = 'flex';
    return;
  }
  itemsEl.style.display = 'block';
  footerEl.style.display = 'block';
  emptyEl.style.display = 'none';
  document.getElementById('cart-drawer-total').textContent = sgMoney(cart.total_price);

  /* On first load the rows are ALREADY correct: sections/site-header.liquid
     rendered them from the same shared snippet. Re-fetching them would be a
     wasted request on every single page view, so the DOMContentLoaded call
     passes skipRows. Everything after a cart CHANGE does need the refetch. */
  if(skipRows) return;

  /* The rows are rendered by the SERVER, not built from this cart object.

     /cart.js carries no metafields, so custom.box_size (the pack size, for
     example "350g*1pc") is not reachable from the browser at all. This
     function used to fall back to '&nbsp;' for every product without a real
     variant title, which is nearly all of them, so the drawer never showed a
     pack size while the cart page and the PDP both did.

     templates/cart.drawer.liquid renders the SAME shared snippet as the
     server-rendered drawer in sections/site-header.liquid, so the two cannot
     drift again. It is layout none, so the response is about 3 KB.

     Shopify's Section Rendering API is the usual tool for this and is NOT
     usable here: ?sections= ignores the theme preview and always serves the
     PUBLISHED theme, so while the redesign is a draft it returns Dawn's
     header, which has no drawer markup at all. Measured 2026-09-22; see the
     comment in templates/cart.drawer.liquid.

     On failure the previous rows are left alone rather than blanking the
     drawer. sgReapply runs again because the rows arrive after the
     synchronous pass in updateCartUI, and Arabic needs to translate them. */
  var renderSeq = ++sgDrawerRenderSeq;
  fetch(window.routes.cart_url + '?view=drawer', {credentials: 'same-origin'})
    .then(function(r){ return r.ok ? r.text() : null; })
    .then(function(html){
      /* Drop this response if a newer refresh has started since. Two of these
         can be in flight at once, and the older one must not repaint rows the
         newer one has already replaced. */
      if(html === null || renderSeq !== sgDrawerRenderSeq) return;
      itemsEl.innerHTML = html;
      sgReapply();
    })
    .catch(function(){});
}
function sgAddToCart(variantId, quantity){
  return fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: [{id: variantId, quantity: quantity || 1}]})
  })
    .then(function(r){ return r.json(); })
    .then(function(){ return sgFetchCart(); })
    .then(function(cart){ updateCartUI(cart); openCartDrawer(); return cart; });
}
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){
    var drawer = document.getElementById('cart-drawer');
    if(drawer && drawer.classList.contains('open')){ closeCartDrawer(); }
    var fav = document.getElementById('fav-drawer');
    if(fav && fav.classList.contains('open')){ closeFavDrawer(); }
  }
});

/* ---------- Product-card inline Add -> stepper (real Shopify Cart AJAX API) ---------- */
function bsRenderAddButton(wrap, variantId){
  wrap.innerHTML = '<button type="button" class="bs-btn" onclick="event.preventDefault(); event.stopPropagation(); bsCardAdd(this, ' + variantId + ');">Add</button>';
}
function bsRenderStepper(wrap, variantId, itemKey, qty){
  wrap.innerHTML = '<div class="bs-stepper">' +
    '<button type="button" class="bs-step-btn bs-step-minus" onclick="event.preventDefault(); event.stopPropagation(); bsCardStep(this, ' + variantId + ', \'' + itemKey + '\', -1);">&minus;</button>' +
    '<span class="bs-step-qty">' + qty + '</span>' +
    '<button type="button" class="bs-step-btn bs-step-plus" onclick="event.preventDefault(); event.stopPropagation(); bsCardStep(this, ' + variantId + ', \'' + itemKey + '\', 1);">+</button>' +
  '</div>';
}
function bsCardAdd(btn, variantId){
  var wrap = btn.closest('.bs-add-wrap');
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
  })
    .then(function(r){ return r.json(); })
    .then(function(data){
      var line = data.items && data.items[0];
      if(line){ bsRenderStepper(wrap, variantId, line.key, line.quantity); }
      return sgFetchCart();
    })
    .then(function(cart){ updateCartUI(cart); bsApplyCartToWraps(cart); });
}
function bsCardStep(btn, variantId, itemKey, delta){
  var wrap = btn.closest('.bs-add-wrap');
  var qtyEl = wrap.querySelector('.bs-step-qty');
  var newQty = (qtyEl ? parseInt(qtyEl.textContent, 10) : 0) + delta;
  fetch(window.routes.cart_change_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: itemKey, quantity: newQty})
  })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      updateCartUI(cart);
      /* Same reason as bsCardAdd: the other wraps for this variant have to
         follow, or the sticky bar and the inline row disagree. A drop to zero
         resets them all to a plain Add button. */
      if(newQty <= 0){
        document.querySelectorAll('.bs-add-wrap[data-variant-id="' + variantId + '"]').forEach(function(w){
          bsRenderAddButton(w, variantId);
        });
      } else {
        bsApplyCartToWraps(cart);
      }
    });
}
/* Split out of bsHydrateCardButtons so a caller that ALREADY has the cart can
   reuse it without a second fetch.

   It exists because the product page now carries the same variant in THREE
   add-wraps at once: the inline buy row, the mobile sticky bar and the desktop
   sticky top bar. bsCardAdd only ever rendered a stepper into the wrap that was
   clicked, so adding from a sticky bar left the inline row still reading "Add
   to cart" for something already in the cart. Applying the returned cart to
   every wrap fixes that, and also syncs a product that appears twice in one
   grid. */
function bsApplyCartToWraps(cart){
  if(!cart || !cart.items){ return; }
  document.querySelectorAll('.bs-add-wrap[data-variant-id]').forEach(function(wrap){
    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    var line = cart.items.filter(function(i){ return i.variant_id === variantId; })[0];
    if(line && line.quantity > 0){ bsRenderStepper(wrap, variantId, line.key, line.quantity); }
  });
}
function bsHydrateCardButtons(){
  if(!window.routes) return;
  sgFetchCart().then(bsApplyCartToWraps);
}

/* ---------- Recently viewed (client-side; no native Shopify equivalent
   without a metafield/app-backed solution, mirrors the favourites drawer's
   approach) ---------- */
/* Entries are stored locale-free: href without the /ar prefix, plus one
   name per language (name_en / name_ar), so a product viewed in English
   still shows its Arabic title on Arabic pages. Older entries carry a
   single "name", read as English. */
function sgTrackRecentlyViewed(item){
  try{
    var key = 'sg_recently_viewed';
    var href = sgLocalePath(item.href, 'en');
    var list = JSON.parse(localStorage.getItem(key)) || [];
    var prev = list.filter(function(i){ return sgLocalePath(i.href, 'en') === href; })[0] || {};
    var entry = {href: href, image: item.image, priceHtml: item.priceHtml,
      name_en: prev.name_en || prev.name, name_ar: prev.name_ar};
    entry['name_' + SG_PAGE_LANG] = item.name;
    list = list.filter(function(i){ return sgLocalePath(i.href, 'en') !== href; });
    list.unshift(entry);
    if(list.length > 12){ list = list.slice(0, 12); }
    localStorage.setItem(key, JSON.stringify(list));
  }catch(e){}
}
function sgRvName(item){
  return item['name_' + SG_PAGE_LANG] || item.name_en || item.name || '';
}
function renderRecentlyViewed(excludeHref){
  var section = document.getElementById('rv-section');
  var track = document.getElementById('rv-track');
  if(!section || !track) return;
  var list = [];
  try{ list = JSON.parse(localStorage.getItem('sg_recently_viewed')) || []; }catch(e){}
  if(excludeHref){
    var ex = sgLocalePath(excludeHref, 'en');
    list = list.filter(function(item){ return sgLocalePath(item.href, 'en') !== ex; });
  }
  if(!list.length) return;
  track.innerHTML = list.map(function(item, i){
    var name = sgRvName(item);
    return '<a class="rv-card" href="' + sgLocalePath(item.href, SG_PAGE_LANG) + '">' +
      '<img loading="lazy" src="' + item.image + '" alt="' + sgEscapeHtml(name) + '">' +
      '<div class="rv-card-body"><h4 data-rv-index="' + i + '">' + sgEscapeHtml(name) + '</h4><span class="rv-card-price">' + item.priceHtml + '</span></div>' +
      '</a>';
  }).join('');
  section.style.display = '';
  /* Fill in titles never seen in this language from Shopify's translation. */
  list.forEach(function(item, i){
    if(item['name_' + SG_PAGE_LANG]) return;
    fetch(sgLocalePath(item.href, SG_PAGE_LANG) + '.js', {credentials: 'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(!p || !p.title) return;
        var h4 = track.querySelector('[data-rv-index="' + i + '"]');
        if(h4){ h4.textContent = p.title; }
        try{
          var all = JSON.parse(localStorage.getItem('sg_recently_viewed')) || [];
          all.forEach(function(e){ if(sgLocalePath(e.href, 'en') === sgLocalePath(item.href, 'en')){ e['name_' + SG_PAGE_LANG] = p.title; } });
          localStorage.setItem('sg_recently_viewed', JSON.stringify(all));
        }catch(e){}
      })
      .catch(function(){});
  });
}

/* ---------- Home Google reviews carousel ---------- */
function scrollHomeReviews(dir){
  var track = document.getElementById('home-reviews-track');
  if(!track) return;
  var card = track.querySelector('.home-review-card');
  var step = card ? card.getBoundingClientRect().width + 20 : 300;
  track.scrollBy({left: dir * step, behavior: 'smooth'});
}
function updateHomeReviewsArrows(){
  var track = document.getElementById('home-reviews-track');
  var prev = document.getElementById('home-reviews-prev');
  var next = document.getElementById('home-reviews-next');
  if(!track || !prev || !next) return;
  prev.classList.toggle('disabled', track.scrollLeft <= 4);
  next.classList.toggle('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
}
(function(){
  var track = document.getElementById('home-reviews-track');
  if(track){
    track.addEventListener('scroll', updateHomeReviewsArrows);
    updateHomeReviewsArrows();
  }
})();

/* ---------- Search (Shopify predictive search endpoint) ---------- */
var sgSearchTimer = null;
function sgSearchInput(e){
  clearTimeout(sgSearchTimer);
  var q = document.getElementById('site-search-input').value.trim();
  if(e.key === 'Escape'){ sgSearchClose(); return; }
  if(e.key === 'Enter'){ sgSearchGo(); return; }
  if(q.length < 2){ sgSearchClose(); return; }
  sgSearchTimer = setTimeout(function(){ sgSearchRender(q); }, 200);
}
/* .site-search is overflow:hidden so the input and button corners stay inside
   its rounded border. The results panel is absolutely positioned inside it, so
   without .search-active flipping the wrapper to overflow:visible the whole
   dropdown is clipped to the 48px input row and is invisible. Opening and
   closing therefore has to toggle BOTH classes, never just .active. */
function sgSearchOpen(){
  var box = document.getElementById('site-search-results');
  var wrap = document.querySelector('.site-search');
  if(box){ box.classList.add('active'); }
  if(wrap){ wrap.classList.add('search-active'); }
}
function sgSearchClose(){
  var box = document.getElementById('site-search-results');
  var wrap = document.querySelector('.site-search');
  if(box){ box.classList.remove('active'); box.innerHTML = ''; }
  if(wrap){ wrap.classList.remove('search-active'); }
}
/* Bolds everything in a suggestion EXCEPT the part the shopper typed, which is
   how the mockup renders them: "bread" stays light, the completion is bold.
   Shopify's own styled_text marks the opposite half and arrives as raw HTML, so
   the split is recomputed here from the plain text instead, and every piece is
   escaped rather than any API HTML being injected into the page. */
function sgHighlightSuggestion(phrase, q){
  var idx = phrase.toLowerCase().indexOf(q.toLowerCase());
  if(idx === -1){ return '<b>' + sgEscapeHtml(phrase) + '</b>'; }
  var before = phrase.slice(0, idx);
  var mid = phrase.slice(idx, idx + q.length);
  var after = phrase.slice(idx + q.length);
  var out = '';
  if(before){ out += '<b>' + sgEscapeHtml(before) + '</b>'; }
  out += sgEscapeHtml(mid);
  if(after){ out += '<b>' + sgEscapeHtml(after) + '</b>'; }
  return out;
}
/* Shopify's suggestion URLs carry _psq/_psid tracking that feeds its search
   analytics, so they are preferred over a hand-built link, but only after
   confirming the value is a same-origin path. type=product is appended to match
   the results page, which renders products only. */
function sgSearchUrl(term, apiUrl){
  if(apiUrl && apiUrl.charAt(0) === '/' && apiUrl.charAt(1) !== '/'){
    return apiUrl + '&type=product';
  }
  return window.routes.search_url + '?q=' + encodeURIComponent(term) + '&type=product';
}
function sgSearchRender(q){
  var box = document.getElementById('site-search-results');
  fetch(window.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=query,product&resources[limit]=6&resources[options][unavailable_products]=last')
    .then(function(r){ return r.json(); })
    .then(function(data){
      var results = (data.resources && data.resources.results) || {};
      var queries = results.queries || [];
      /* The mockup shows at most five products under the suggestions; the API
         limit applies to every resource type at once, so products are trimmed
         here rather than in the request. */
      /* The predictive-search endpoint returns price as a bare decimal string
         ("21.50"), unlike the Liquid `money` filter, so the currency has to be
         added here or the rows read "21.50" with no unit. AED is hardcoded to
         match sgMoney() elsewhere in this file; revisit both together if the
         store ever sells in a second currency. */
      var products = (results.products || []).slice(0, 5);
      var html = '';

      if(queries.length){
        html += '<div class="site-search-section-label">Suggestions</div>';
        html += queries.map(function(s){
          return '<a class="site-search-suggestion" href="' + sgSearchUrl(s.text, s.url) + '">' +
            sgHighlightSuggestion(s.text, q) + '</a>';
        }).join('');
      }

      if(products.length){
        if(queries.length){ html += '<hr class="site-search-divider">'; }
        html += '<div class="site-search-section-label">Products</div>';
        html += products.map(function(p){
          return '<a class="site-search-result" href="' + p.url + '">' +
            '<img loading="lazy" src="' + (p.featured_image ? p.featured_image.url : '') + '" alt="' + sgEscapeHtml(p.title) + '">' +
            '<div class="site-search-result-info">' +
              '<span class="site-search-result-name">' + sgEscapeHtml(p.title) + '</span>' +
              '<span class="site-search-result-price">AED ' + p.price + '</span>' +
            '</div>' +
          '</a>';
        }).join('');
      }

      if(!queries.length && !products.length){
        html = '<div class="site-search-empty">No products found for &ldquo;' + sgEscapeHtml(q) + '&rdquo;</div>';
      }

      html += '<a class="site-search-footer" href="' + sgSearchUrl(q) + '">Search for &ldquo;' + sgEscapeHtml(q) + '&rdquo;' +
        '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></a>';

      box.innerHTML = html;
      sgSearchOpen();
    });
}
function sgSearchGo(){
  var q = document.getElementById('site-search-input').value.trim();
  if(!q) return;
  // type=product keeps the results page consistent with this dropdown, which
  // already queries products only (resources[type]=product above). Without it
  // Shopify also returns pages and articles, which the results page has no
  // design for, and the heading count would then exceed the cards shown.
  window.location.href = window.routes.search_url + '?q=' + encodeURIComponent(q) + '&type=product';
}
document.addEventListener('click', function(e){
  var search = document.querySelector('.site-search');
  if(search && !search.contains(e.target)){ sgSearchClose(); }
});

/* ---------- Init ---------- */
document.addEventListener('DOMContentLoaded', function(){
  /* The search field's inline handler is onkeyup, which covers physical typing
     and the Enter/Escape keys but never fires for a paste, a phone keyboard's
     predictive-text insertion, voice dictation or browser autofill: the value
     changes and the dropdown stays shut. Listening to 'input' as well catches
     all of those. Both paths share sgSearchTimer, so ordinary typing still
     renders only once, and 'input' carries no .key so the Enter and Escape
     branches simply do not match. */
  var searchInput = document.getElementById('site-search-input');
  if(searchInput){ searchInput.addEventListener('input', sgSearchInput); }

  initFavouriteHearts();
  updateFavCount();
  sgInitDrawerSwipe();
  if(window.routes){ sgFetchCart().then(function(cart){ updateCartUI(cart, true); }); }
  bsHydrateCardButtons();
  if(window.SG_CURRENT_PRODUCT){
    sgTrackRecentlyViewed(window.SG_CURRENT_PRODUCT);
    renderRecentlyViewed(window.SG_CURRENT_PRODUCT.href);
  } else {
    renderRecentlyViewed();
  }
});
